import React, { useState ,useEffect } from 'react';
import "./MessageCodes.css";

import iconPlus from '../../Images/IconPlus.svg';
import iconMinus from '../../Images/IconMinus.svg';

const A1Invoice = ({ data ,item,showMaximumChat }) => {
  let invoiceItems = [];
  let hasError = false;

  let showToggle
  useEffect(() => {

    if (showToggle) {
      setOpen(showToggle || false)
    }
  }, [showToggle])

  try {
    if (typeof item?.data === 'string') {
      invoiceItems = JSON.parse(item?.data);
    } else if (Array.isArray(item?.data)) {
      invoiceItems = item?.data;
    } else {
   
      hasError = true;
    }
  } catch (e) {
    hasError = true;
  }

  showToggle = invoiceItems[0]?.isOneView === true ;
  const [open, setOpen] = useState(showToggle);
//   if(invoiceItems?.length === 0  ){
//     return
//   }

  let heading = (() => {
    try {
        return JSON.parse(item?.text);
    } catch (e) {
        return item?.text;
    }
   })();
  

  //ONE toggle for whole component




  if (hasError) {
    return <div>Invalid data format</div>;
  }

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        padding: '0px 12px',
        border: showToggle && "1px solid #b8b8b8",
       borderRadius:  showToggle && "12px",
       margin: showToggle && "20px 0px",
       background : showToggle &&  "rgb(248 220 255 / 96%)",
       boxShadow: showToggle
       ? "inset 0 2px 6px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.08)"
       : "none",
     transition: showToggle && "box-shadow 0.3s ease"
      }}
    >

      {showToggle && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            margin: '10px 0px',
            fontWeight: 'bold',
            fontSize: '16px',
            padding:'12px 12px 12px 0px;',
          }}
          onClick={() => setOpen(!open)}
        >
         {/* <div className='A3f'>{heading?.heading}</div> */}
         <h3
        style={{ fontSize: !showMaximumChat && "13px" }}
        className="a3billing-heading"
      >
        {heading?.heading}
      </h3>
          <img
            src={open ? iconMinus : iconPlus}
            alt="toggle"
            style={{ width: '20px', height: '20px' }}
          />
        </div>
      )}

      {/*  Whole Component Show/Hide */}
      {open && (
        <div
          style={{
            height: '350px',
            overflowY: 'auto',
            paddingRight: '5px'
          }}
        >
          {invoiceItems.map((item, idx) => {
            const descriptionParts = item?.description?.split(',');
            const paymentInfo = descriptionParts?.[0] || '';
            const transactionId = paymentInfo.split(':')[1]?.trim();
            const receiptNumber =
              descriptionParts?.[1]?.split(':')[1]?.trim() || null;
            const amount = item?.amount;

            return (
              <div
                key={idx}
                style={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  marginBottom: '12px',
                  backgroundColor: 'white',
                  overflow: 'hidden'
                }}
              >
                {/* Card Title */}
                <div
                  style={{
                    padding: '8px 12px',
                    fontWeight: 'bold',
                    borderBottom: '1px solid #e0e0e0'
                  }}
                >
                  {item?.title}
                </div>

                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr'
                  }}
                >
                  {/* Left side */}
                  <div
                    style={{
                      padding: '8px 12px',
                      borderRight: '1px solid #f0f0f0'
                    }}
                  >
                    <div style={{ marginBottom: '4px' }}>
                      {paymentInfo.replace(
                        `Transaction Id:${transactionId}`,
                        ''
                      )?.trim()}
                    </div>

                    {transactionId && (
                      <div style={{ marginBottom: '4px' }}>
                        Transaction ID: {transactionId}
                      </div>
                    )}

                    {receiptNumber && (
                      <div style={{ marginBottom: '4px' }}>
                        Receipt No: {receiptNumber}
                      </div>
                    )}
                  </div>

                  {/* Right side */}
                  <div
                    style={{
                      padding: '8px 12px',
                      textAlign: 'right',
                      fontWeight: 'bold',
                      color: amount.startsWith('-') ? '#f44336' : '#4CAF50',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                  >
                    {amount}
                  </div>

                  <div
                    style={{
                      padding: '8px 12px',
                      textAlign: 'right',
                      color: '#757575'
                    }}
                  >
                    {item?.date}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

    {!open && !showToggle && (
        <div
          style={{
            height: '350px',
            overflowY: 'auto',
            paddingRight: '5px'
          }}
        >
          {invoiceItems.map((item, idx) => {
            const descriptionParts = item?.description?.split(',');
            const paymentInfo = descriptionParts?.[0] || '';
            const transactionId = paymentInfo.split(':')[1]?.trim();
            const receiptNumber =
              descriptionParts?.[1]?.split(':')[1]?.trim() || null;
            const amount = item?.amount;

            return (
              <div
                key={idx}
                style={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  marginBottom: '12px',
                  backgroundColor: 'white',
                  overflow: 'hidden'
                }}
              >
                {/* Card Title */}
                <div
                  style={{
                    padding: '8px 12px',
                    fontWeight: 'bold',
                    borderBottom: '1px solid #e0e0e0'
                  }}
                >
                  {item?.title}
                </div>

                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 1fr'
                  }}
                >
                  {/* Left side */}
                  <div
                    style={{
                      padding: '8px 12px',
                      borderRight: '1px solid #f0f0f0'
                    }}
                  >
                    <div style={{ marginBottom: '4px' }}>
                      {paymentInfo.replace(
                        `Transaction Id:${transactionId}`,
                        ''
                      )?.trim()}
                    </div>

                    {transactionId && (
                      <div style={{ marginBottom: '4px' }}>
                        Transaction ID: {transactionId}
                      </div>
                    )}

                    {receiptNumber && (
                      <div style={{ marginBottom: '4px' }}>
                        Receipt No: {receiptNumber}
                      </div>
                    )}
                  </div>

                  {/* Right side */}
                  <div
                    style={{
                      padding: '8px 12px',
                      textAlign: 'right',
                      fontWeight: 'bold',
                      color: amount.startsWith('-') ? '#f44336' : '#4CAF50',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                  >
                    {amount}
                  </div>

                  <div
                    style={{
                      padding: '8px 12px',
                      textAlign: 'right',
                      color: '#757575'
                    }}
                  >
                    {item?.date}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

    </div>
  );
};

export default A1Invoice;
